export const SERVER_KEY = 'ssr';

export const ActionTypes = {
    IS_HTTPS: '@@is_https',
    FETCH_METRICS: '@@fetch_metrics',
};
